import Quill from 'quill';

export class CustomLinkModule {
    constructor() {
      const Link = Quill.import('formats/link') as any;

      class CustomLink extends Link {
            static create(value) {
                const node = super.create(value);
                let url = node.getAttribute('href');

                if (url.startsWith(window.location.origin)) {
                    let cleanedUrl = url.substring(window.location.origin.length);
                    node.setAttribute('href', cleanedUrl);

                    // Quill 2 forces target="_blank"/rel on every link, which breaks
                    // in-app (SPA) navigation for internal links. Remove them so the
                    // router can handle relative URLs.
                    node.removeAttribute('target');
                    node.removeAttribute('rel');
                }

                return node;
            }
      }

      Quill.register(CustomLink as any, true);
    }

  }
